import { render, staticRenderFns } from "./historyInfo.vue?vue&type=template&id=3c770b75&scoped=true&"
import script from "./historyInfo.vue?vue&type=script&lang=js&"
export * from "./historyInfo.vue?vue&type=script&lang=js&"
import style0 from "./historyInfo.vue?vue&type=style&index=0&id=3c770b75&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c770b75",
  null
  
)

export default component.exports